import * as Blurhash from "blurhash"

export async function fromFile(
  file: File,
): Promise<HTMLVideoElement | undefined> {
  return new Promise<HTMLVideoElement | undefined>((resolve) => {
    const video = document.createElement("video")
    const url = URL.createObjectURL(file)
    video.onloadedmetadata = () => {
      URL.revokeObjectURL(url)
      resolve(video)
    }
    video.onerror = () => {
      URL.revokeObjectURL(url)
      resolve(undefined)
    }
    video.src = url
    video.load()
  })
}

export async function toBlurhash(video: HTMLVideoElement): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const canvas = document.createElement("canvas")
    canvas.width = video.videoWidth
    canvas.height = video.videoHeight

    const ctx = canvas.getContext("2d")!

    // Set video to first frame
    video.currentTime = 0

    video.onseeked = () => {
      try {
        ctx.drawImage(video, 0, 0)
        const data = ctx.getImageData(0, 0, canvas.width, canvas.height)
        const blurhash = Blurhash.encode(
          data.data,
          data.width,
          data.height,
          4,
          4,
        )
        resolve(blurhash)
      } catch (error) {
        reject(error)
      }
    }

    video.onerror = () => reject(new Error("Failed to seek video"))
  })
}
